import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { permissionByWorkroomName } from '../../../../utils/permissionUtils';
import { formatTelephone } from '../../../../utils';
import Card from 'components/Card';
import { ResourceCardElement } from 'components/ResourceCardElements';
import styles from 'styles/resourceCard';
import cx from 'classnames';

const UserCard = ({
  user, type, children, showEmployableType, role, workrooms, clickable,
}) => {
  const canViewContactInfo = () => type !== 'installers' ||
    permissionByWorkroomName(role, user.perms_workrooms, workrooms);
  const cardClasses = cx({
    [styles.inactive]: !user.active || !canViewContactInfo(),
    [styles.resourceCard]: true,
  });
  const cardContent = (<Card key={user.id} className={cardClasses} inactive={!user.active}>
    {showEmployableType && <ResourceCardElement title="Type" size="medium">
      {user.employable_type}
      {user.position && <small><br />{user.position}</small>}
    </ResourceCardElement>}
    <ResourceCardElement title="Name" size="medium">
      {user.name}
      {user.pending && <small><br />[Account Pending]</small>}
    </ResourceCardElement>
    {children}
    <ResourceCardElement title="Primary Phone" size="medium">
      {user.primary_phone ? formatTelephone(user.primary_phone) : 'N/A'}
      <span className={styles.phoneType}>({user.primary_phone_type})</span>
    </ResourceCardElement>
    <ResourceCardElement title="Email" size="large" value={user.email} />
  </Card>);
  if (!canViewContactInfo()) {
    return (<Card
      key={user.id}
      className={cardClasses}
      inactive={!user.active || !canViewContactInfo()}
    >
      <ResourceCardElement title="Unavailable" size="medium" >
        Installer {user.id} unavailable due to workroom restrictions
      </ResourceCardElement>
    </Card>);
  }
  return clickable ? (<Link className={styles.viewLink} to={`/${type}/${user.id}`}>
    {cardContent}
  </Link>) : cardContent;
};

UserCard.defaultProps = { role: '', workrooms: [], clickable: true };

UserCard.propTypes = {
  user: PropTypes.shape({
    id: PropTypes.number.isRequired,
    active: PropTypes.bool.isRequired,
    pending: PropTypes.bool.isRequired,
    email: PropTypes.string.isRequired,
    primary_phone: PropTypes.string,
    primary_phone_type: PropTypes.string,
    employable_type: PropTypes.string,
    position: PropTypes.string,
  }).isRequired,
  children: PropTypes.node,
  type: PropTypes.string.isRequired,
  showEmployableType: PropTypes.bool,
  role: PropTypes.string,
  workrooms: PropTypes.array,
  clickable: PropTypes.bool,
};

export default UserCard;



// WEBPACK FOOTER //
// ./client/app/shared/components/users/UserCard/index.jsx